module.exports = __webpack_public_path__ + "img/2023-08_experience-uga.5558fa6b.png";